import React from 'react';
import axios from 'axios';
import { ReqAddGroup } from '../types/api/Groups';
import { ApiUrl } from '../conf/config';

export const useAddGroup = () => {
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(false);

  const addGroup = (group: ReqAddGroup) => {
    setError(false);
    setLoading(true);

    const token = sessionStorage.getItem('token');

    axios
      .post(`${ApiUrl}/admin/api/v1/groups`, group, {
        headers: { Authorization: 'Bearer ' + token },
      })
      .then((res) => {
        console.log(res.data);
      })
      .catch((error) => {
        console.error(error);
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return { addGroup, loading, error };
};
